export const UPDATE_RISK_DATA = 'UPDATE_RISK_DATA';
export const UPDATE_RANGE_DATA = 'UPDATE_RANGE_DATA';
export const UPDATE_INVEST_RETURN_DATA = 'UPDATE_INVEST_RETURN_DATA';
export const UPDATE_MAX_DECLINE_DATA = 'UPDATE_MAX_DECLINE_DATA';
export const UPDATE_STOCK_MARKET_DATA = 'UPDATE_STOCK_MARKET_DATA';
export const UPDATE_AGE_RANGE_DATA = 'UPDATE_AGE_RANGE_DATA';
export const UPDATE_PLANNED_DATA = 'UPDATE_PLANNED_DATA';
export const UPDATE_SIDEBAR_TEXT_DATA = 'UPDATE_SIDEBAR_TEXT_DATA';
